// extracted by mini-css-extract-plugin
export default {"faq":"yyv_rcQol75FKWHtqXmN","faqExpanded":"PEZtuVn20gJHg6i7lDLU"};